import React from 'react'
import About from '../components/About'


function AboutPage() {
  return (
    <>
    <div className="main">
      <p>About Me</p>
      </div>
      <About />
    </>
  )
}

export default AboutPage
